import React, { useState, useEffect } from 'react'
import { Link, Redirect, useParams } from "react-router-dom"
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { host, Host } from '../App';
import Axios from 'axios'
import '../Responsive.css'
import BorderedLinesCell from './Column_Border';



function Received_raw_material() {
  var [del, setdel] = useState(1);
  var int = 4;
  var [postList, setPostList] = useState([]);
  var [SheetID, setSheetID] = useState("");
  var [Item_No, setItem_No] = useState("");
  var [Operator, setOperator] = useState("");
  var [Chair_Part_Type, setChair_Part_Type] = useState("");
  var [poNo, setpoNo] = useState([]);
  var [Item_Desc, setItem_Desc] = useState("");
  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState('2026-01-01');
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  var [Supplier, setSupplier] = useState({});
  var [LotNo, setLotNo] = useState("");
  var [Customers, setCustomers] = useState([]);
  var [partNo, setpartNo] = useState("");
  var [order, setOrder] = useState("1");
  const [DetailedView, setDetailedView] = useState(true);
  var Total = 0;
  const user = JSON.parse(window.localStorage.getItem("Name"));
  const [employees, setEmployees] = useState([]);
  var [PartLayout, setPartLayout] = useState([]);

  const [data, setData] = useState([{ PO_No: "", Item_No: "", ReceivedQty: "", ActualReceiveddate: "", Invoice_cost: "", Unit_cost: "", PO_CURRENCY: "", Supplier: "", Item_Description: "", QTY: "", Unit_price_po: "", ETA: "", GRN_No: "", Unit: "" },]);

  const [Detaileddata, setDetaileddata] = useState([{ PO_No: "", Item_No: "", ReceivedQty: "", ActualReceiveddate: "", Invoice_cost: "", Unit_cost: "", PO_CURRENCY: "", Supplier: "", Item_Description: "", QTY: "", Unit_price_po: "", ETA: "", GRN_No: "", Unit: "" },]);

  //var token = sessionStorage.getItem("token");
  var token = (window.localStorage.getItem("acessToken"));

  const queryParams = {
    Sheet_Id: JSON.stringify(SheetID),
    Item_No: JSON.stringify(Item_No),
    Lot_No: JSON.stringify(LotNo),
    CutDate1: Postartdate,
    CutDate2: Poenddate,
    Part_No: JSON.stringify(partNo),
    Chair_Part_Type: Chair_Part_Type,
    Item_Desc: JSON.stringify(Item_Desc),
    Operator: Operator,
    token: token,
    User: user
  };

  const toggle_Detailedview = () => {
    setDetailedView(!DetailedView);

  };

  useEffect(() => {
    Axios.get(`https://` + host + `/api/WIP/search`, { params: queryParams }).then((data) => {
      setDetaileddata(data.data);
    })
  }, [SheetID, Item_No, LotNo, Postartdate, Poenddate, partNo, Chair_Part_Type, Operator, del]);

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/WIP_special/search`, { params: queryParams }).then((data) => {
      setData(data.data);
    })
  }, [SheetID, Item_No, LotNo, Postartdate, Poenddate, partNo, Chair_Part_Type, Operator, del]);

  useEffect(() => {
    Axios.get(`https://` + host + `/Woodshop/Part_layout`, { params: queryParams }).then((data) => {
      setPartLayout(data.data)
    });
  }, [])
  useEffect(() => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/pono/${token}`).then((data) => {
      setpoNo(data.data)
    });
  }, [])
  // to retreive customers
  useEffect(() => {
    Axios.get(`https://` + host + `/api/Received_Raw_Material/suppliers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [])

  useEffect(() => {
    Axios.get(`https://` + host + `/api/employees_all/${token}`).then((data) => {
      setEmployees(data.data);
    });
  }, []);

  const [changedRows, setChangedRows] = useState(new Set());
  const handleUpdate = (e, index, key) => {
    const { value } = e.target;
    updateData(index, key, value);
  };


  //logics for Update PO  

  const [changedRows_Detaileddata, setChangedRows_Detaileddata] = useState(new Set());
  const handleUpdate_Detaileddata = (e, index, key) => {
    const { value } = e.target;
    updateData_Detaileddata(index, key, value);

  };
  const updateData_Detaileddata = (index, key, value) => {
    setDetaileddata(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;
      newData[index]['WIP_employee'] = user;
      return newData;
    });
    // Add the index of the changed row to the set of changed rows
    setChangedRows_Detaileddata(prevRows => new Set(prevRows).add(index));
  };
  const updateData = (index, key, value) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[index]['WIP_employee'] = user;
      console.log(user);
      newData[index][key] = value;
      setChangedRows(prevRows => {
        const newSet = new Set(prevRows);
        newSet.add(index);
        return newSet;
      });
      // Helper function to check if a date is valid
      setChangedRows(prevRows => {
        const newSet = new Set(prevRows);
        newSet.add(index);
        return newSet;
      });
      return newData;
    });
  };

  const submitValue = (e, index) => {
    const newData = [...data];
    const part = newData[index].Main_PartNo;  // Get the entered Part_No
    const qty = newData[index].New_Qty;       // Get the quantity

    // Find the corresponding part in PartLayout
    const partEntry = PartLayout.find((x) => x.Part_No === part);

    if (partEntry) {
      const dependency = partEntry.WIP_Dependency;

      console.log(`Dependency: ${dependency}, Qty: ${qty}`);

      if (dependency === 'YES') {
        // Get all Woodshop_Part_No associated with the same Part_No
        console.log("called");
        const dependentParts = PartLayout
          .filter((x) => x.Part_No === part)
          .map((x) => x.Woodshop_Part_No);

        console.log(`Main Part: ${part}, Dependency: Yes, Affected Parts: ${dependentParts}`);

        // Match with data rows and update New_Qty
        newData.forEach((row, index) => {
          if (dependentParts.includes(row.Part_No)) {
            // Call handleUpdate to update New_Qty for matched rows
            handleUpdate({ target: { value: qty } }, index, 'New_Qty');
          }
        });
        console.log(newData);
      } else {
        // newData[index].DependentParts = [];
      }
    }

    setData(newData);
  };

  const Delete = (SrNo) => {
    setdel(del = del + 1)
    Axios.delete(`https://` + host + `/api/ReceivedRawMaterial/Delete/${SrNo},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 1000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
          });

        }
      })
      .catch(function (error) {
        console.log(error.response);
      });

  };
  const Update = () => {

    const changedData = [...changedRows].map(index => {
      return data[index];
    });
    console.log(changedData);

    const filteredData = [];
    changedData.forEach(item => {
      if (
        item.New_Qty &&
        item.Operator
      ) {
        const newData = [
          item.Sheet_Id,
          item.Item_No,
          item.Lot_No,
          item.Chair_Part_Type,
          item.Part_No,
          item.Dimensions,
          item.New_Qty,
          item.Cut_Date,
          item.Operator,
          item.Status,
          item.Remarks,
          user
        ];

        filteredData.push(newData);
      }
    });
    console.log(filteredData);

    if (changedData.length > 0) {
      Axios.post(`https://` + host + `/woodshop/finishedParts`, { filteredData: filteredData, token: token })
        .then((response) => {
          if (response.status === 200) {
            const numberInputs = document.querySelectorAll('input[type="number"]');
            numberInputs.forEach(input => {
              input.value = '';
            });
            toast.success(response.data.message, {
              autoClose: 3000,
              position: toast.POSITION.TOP_RIGHT,
              style: { fontSize: '24px', borderRadius: '10px' },
            });
            setdel(del = del + 1);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        })
    } else if (changedData.length < 0 || changedData.length === 0) {
      toast.error("No Valid Data !", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '24px', borderRadius: '10px' },
      });
    }

    setdel(del = del + 1)
  };

  // helper to get the min remaining-subpart value (or 0)
  const getLowestSubpart = (subParts) => {
    if (!subParts) return 0;
    // find all numbers in the string
    const matches = subParts.match(/\d+/g);
    if (!matches) return 0;
    // turn them into ints
    const nums = matches.map(n => parseInt(n, 10));
    // return the smallest
    return Math.min(...nums);
  };
  const getLowestqty = (subParts) => {
    if (!subParts) return 0;

    const str = String(subParts); // ensure it's a string
    const matches = str.match(/\d+/g);
    if (!matches) return 0;

    const nums = matches.map(n => parseInt(n, 10));
    return Math.min(...nums);
  };


  useEffect(() => {
    if (changedRows.size > 0) {
      const changedData = [...changedRows].map(index => data[index]).filter(Boolean);

    }
  }, [changedRows, data]);

  const print = () => {
    {/* const changedData = [...changedRows].map(index => {
      return data[index];
    });
    console.log(changedData);
       */}
    const changedDataDetaileddata = [...changedRows_Detaileddata].map(index => {
      return Detaileddata[index];
    });
    console.log(changedDataDetaileddata);

  }

  const Detailed_Submit = () => {

    const changedDataDetaileddata = [...changedRows_Detaileddata].map(index => {
      return Detaileddata[index];
    });
    console.log(changedDataDetaileddata);

    const filteredData = [];
    changedDataDetaileddata.forEach(item => {
      if (
        item.New_Qty &&
        item.Operator
      ) {
        const newData = [
          item.Sheet_Id,
          item.Item_No,
          item.Lot_No,
          item.Chair_Part_Type,
          item.Sub_part_No,
          item.Dimensions,
          item.New_Qty,
          item.Cut_Date,
          item.Operator,
          item.Status,
          item.Remarks,
          user
        ];

        filteredData.push(newData);
      }
    });
    console.log(filteredData);

    if (changedDataDetaileddata.length > 0) {
      Axios.post(`https://` + host + `/woodshop/finishedParts`, { filteredData: filteredData, token: token })
        .then((response) => {
          if (response.status === 200) {
            const numberInputs = document.querySelectorAll('input[type="number"]');
            numberInputs.forEach(input => {
              input.value = '';
            });
            toast.success(response.data.message, {
              autoClose: 3000,
              position: toast.POSITION.TOP_RIGHT,
              style: { fontSize: '24px', borderRadius: '10px' },
            });
            setdel(del = del + 1);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        })
    } else if (changedDataDetaileddata.length < 0 || changedDataDetaileddata.length === 0) {
      toast.error("No Valid Data !", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '24px', borderRadius: '10px' },
      });
    }

    setdel(del = del + 1)
  };
  return (
    <div className="MainPage_data">
      <div class="Container">
        <ToastContainer />
        <div class="row">
          <div class="col" >


            <div class="row">
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Sheet ID' list="SheetID" onChange={(e) => {
                setSheetID(e.target.value)
              }} />
              <datalist id="SheetID">
                <option></option>
                {data.map(x => {
                  return <option>{x.Sheet_Id}</option>
                })}
              </datalist>
            </div >
          </div >
          <div class="col">
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Item No' list='Itemno' onChange={(e) => {
                setItem_No(e.target.value)
              }} />
              <datalist id="Itemno">
                <option></option>
                {data.map(x => {
                  return <option>{x.Item_No}</option>
                })}
              </datalist>
            </div>
          </div><div class="col">
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Part No' list='Partno' onChange={(e) => {
                setpartNo(e.target.value)
              }} />
              <datalist id="Partno">
                <option></option>
                {data.map(x => {
                  return <option>{x.Part_No}</option>
                })}
              </datalist>
            </div>
          </div>
          <div class="col">
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='LOT No' list='Lot_No' onChange={(e) => { setLotNo(e.target.value) }} />
              <datalist id="Lot_No">
                <option></option>
                {data.map(x => {
                  return <option>{x.Lot_No}</option>
                })}
              </datalist>
            </div>
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Item DESCRIPTION' list="Itemdesc" />
              <datalist id="Itemdesc">
                <option></option>
                {postList.map(x => {
                  return <option>{x.Item_Description}</option>
                })}
              </datalist>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col" id='moldng'>
                <div class="row">
                  {/* Grab the Itemicular dates */}
                  <input type='date' class="form-control form-rounded" placeholder='PO SHIP DATE' defaultValue={Postartdate} onChange={(e) => {
                    setPoStartdate(e.target.value)
                  }} id='supplychain-button' />
                  {/*<button class="btn btn-success" onClick={dates}>Submit</button > */}
                  <span class="tooltiptext">Filter By PO DATE </span>
                </div>
                <div class="row">
                  <button class="btn btn-primary" onClick={toggle_Detailedview} >Detailed View</button>
                </div>
              </div>
              <div class="col">
                <input type='date' id='supplychain-button' class="form-control form-rounded" placeholder='Operator' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
                  setPoEnddate(e.target.value)
                }} />
              </div>
            </div>
          </div>
          <br></br>
          <br></br>
          {DetailedView ?
            <div id='RRM_table'>
              {/* User view */}

              <table class="table table-bordered" id='RRM'>
                <thead>
                  <tr>
                    <th hidden>SHEET ID</th>
                    <th hidden>ITEM NO</th>
                    <th>LOT NO</th>
                    <th hidden>CHAIR PART TYPE</th>
                    <th>PART NAME</th>
                    <th>SHEET TYPE</th>
                    <th>QTY</th>
                    <th>CUT DATE</th>
                    <th>OPERATOR</th>
                    <th>Subparts</th>
                    <th>QTY</th>
                    <th>Operator</th>
                    <th>Submit</th>
                  </tr>
                </thead>
                {data
                  .filter(val => getLowestSubpart(val.RemainingSubParts) > 0)
                  .map((val, index) => {
                    return (
                      <tbody key={index} >
                        <tr key={`${val.Id}-${val.Item_No}`}>
                          <td hidden>{val.Sheet_Id}</td>
                          <td hidden>{val.Item_No}</td>
                          <td>{val.Lot_No}</td>
                          <td hidden>{val.Chair_Part_Type}</td>
                          <td>{val.Part_No}</td>
                          <td>{val.Dimensions}</td>
                          <td>
                            {
                              (() => {
                                // default to empty string so .split never blows up
                                const lines = (val.RemainingSubParts || '').split('\n');
                                // extract numbers, filter out invalids
                                const nums = lines
                                  .map(line => {
                                    const m = line.match(/\d+/);
                                    return m ? parseInt(m[0], 10) : NaN;
                                  })
                                  .filter(n => !isNaN(n));
                                // if we found at least one number, take the min; otherwise 0
                                return nums.length > 0 ? Math.min(...nums) : 0;
                              })()
                            }
                          </td>


                          <td>{val.Cut_Date ? val.Cut_Date.slice(0, 10) : ''}</td>
                          <td>{val.Operator}</td>
                          <BorderedLinesCell text={val.RemainingSubParts} />
                          <td>
                            {(() => {
                              // 1) get lines or empty array
                              const lines = (val.RemainingSubParts || '').split('\n');
                              // 2) parse out numbers, drop invalids
                              const nums = lines
                                .map(line => {
                                  const m = line.match(/\d+/);
                                  return m ? parseInt(m[0], 10) : NaN;
                                })
                                .filter(n => !isNaN(n));
                              // 3) determine the max allowed (lowest of those numbers), default to 0
                              const maxAllowed = nums.length > 0 ? Math.min(...nums) : 0;

                              return (
                                <input
                                  type="number"
                                  className="form-control"
                                  // HTML-level enforcement
                                  min={0}
                                  max={maxAllowed}
                                  placeholder={`0 – ${maxAllowed}`}
                                  // keep controlled if you’re using value from state:
                                  // value={val.New_Qty}
                                  onChange={e => {
                                    let v = parseInt(e.target.value, 10) || 0;
                                    // 4) clamp against maxAllowed
                                    if (v > maxAllowed) v = maxAllowed;
                                    e.target.value = v;
                                    handleUpdate(e, index, 'New_Qty');
                                  }}
                                  onBlur={e => submitValue(e, index)}
                                />
                              );
                            })()}
                          </td>

                          <td>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={user}
                              onBlur={(e) => handleUpdate(e, index, 'WIP_employee')}
                              list='employee'
                            />
                            <datalist id="employee">
                              <option></option>
                              {employees.map(x => {
                                return <option key={x.Emp_ID}>{x.Name}</option>
                              })}
                            </datalist>
                          </td>
                          <td>
                            <button className='btn btn-primary' onClick={Update}>Submit</button>
                          </td>

                        </tr>
                      </tbody>
                    )
                  }
                  )}

              </table>
            </div>
            : <div id='RRM_table'>
              {/* Detailed view */}
              <table class="table table-bordered" id='RRM'>
                <thead>
                  <tr>
                    <th>SHEET ID</th>
                    <th>ITEM NO</th>
                    <th>LOT NO</th>
                    <th>CHAIR PART TYPE</th>
                    <th>PART NAME</th>
                    <th>DIMENSIONS</th>
                    <th>QTY</th>
                    <th>CUT DATE</th>
                    <th>OPERATOR</th>
                    <th>STATUS</th>
                    <th>SCRAP</th>
                    <th>REMARKS</th>
                    <th>QTY</th>
                    <th>Operator</th>
                    <th>Submit</th>
                  </tr>
                </thead>
                {Detaileddata
                  .filter(val => getLowestqty(val.Remained_QTY) > 0)
                  .map((val, index) => {
                    return (
                      <tbody key={index} >
                        <tr key={`${val.Id}-${val.Item_No}`}>
                          <td>{val.Sheet_Id}</td>
                          <td>{val.Item_No}</td>
                          <td>{val.Lot_No}</td>
                          <td>{val.Chair_Part_Type}</td>
                          <td>{val.Sub_Part_Name}</td>
                          <td>{val.Dimensions}</td>
                          <td>{val.Remained_QTY}</td>
                          <td>{val.Cut_Date ? val.Cut_Date.slice(0, 10) : ''}</td>
                          <td>{val.Operator}</td>
                          <td>{val.Status}</td>
                          <td>{val.Scrap}</td>
                          <td>{val.Remarks}</td>
                          <td>
                            {(() => {
                              // 1. Normalize to an array of “lines” (strings)
                              const raw = val.Remained_QTY;
                              let lines;

                              if (typeof raw === 'string') {
                                // already a string: split on newlines
                                lines = raw.split(/\r?\n/);
                              } else if (Array.isArray(raw)) {
                                // if it's already an array, just map every entry to string
                                lines = raw.map(item => String(item));
                              } else if (raw == null) {
                                // null or undefined → empty
                                lines = [];
                              } else {
                                // some other type (number, object) → stringify and split
                                lines = String(raw).split(/\r?\n/);
                              }

                              // 2. Extract all the numbers from each line
                              const nums = lines
                                .map(line => {
                                  const m = line.match(/\d+/);
                                  return m ? parseInt(m[0], 10) : NaN;
                                })
                                .filter(n => !isNaN(n));

                              // 3. Compute the “maxAllowed” (i.e. your minimum remaining qty)
                              const maxAllowed = nums.length > 0 ? Math.min(...nums) : 0;

                              // 4. Render the input
                              return (
                                <input
                                  type="number"
                                  className="form-control"
                                  min={0}
                                  max={maxAllowed}
                                  placeholder={`0 – ${maxAllowed}`}
                                  onChange={e => {
                                    let v = parseInt(e.target.value, 10) || 0;
                                    if (v > maxAllowed) v = maxAllowed;
                                    e.target.value = v;
                                    handleUpdate_Detaileddata(e, index, 'New_Qty');
                                  }}
                                />
                              );
                            })()}
                          </td>


                          <td>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={user}
                              onBlur={(e) => handleUpdate_Detaileddata(e, index, 'WIP_employee')}
                              list='employee'
                            />
                            <datalist id="employee">
                              <option></option>
                              {employees.map(x => {
                                return <option key={x.Emp_ID}>{x.Name}</option>
                              })}
                            </datalist>
                          </td>
                          <td>
                            <button className='btn btn-primary' onClick={Detailed_Submit}>Submit</button>

                          </td>
                        </tr>
                      </tbody>
                    )
                  }
                  )}

              </table>
            </div>}
        </div >
      </div >
    </div>
  )
}

export default Received_raw_material

